// extracted by mini-css-extract-plugin
export var inlineLink = "_6y-0";
export var inlineLinkButton = "_6y-1";